import React, { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import Checkbox from '@common/checkbox';
import Icon from '@common/assets';

import { getEnumKeyByValue } from '@utils/enumUtil';
import classnames from 'classnames/bind';
import styles from './checkboxArea.module.scss';
const cx = classnames.bind(styles);

interface EnumType {
  [key: string]: string;
}

interface CheckboxAreaProps<T extends EnumType> {
  prefix: string;
  enumTypes: T;
  title: string;
}

const CheckboxArea = <T extends EnumType>({ prefix, enumTypes, title }: CheckboxAreaProps<T>) => {
  const [isOpen, setIsOpen] = useState(true);
  const { getValues } = useFormContext();
  const { field: checkFields } = useController({
    name: prefix,
  });
  const checkedValue = getValues(prefix) ?? [];
  const enumValues = Object.values(enumTypes);

  const onSelectOtherType = (select: string, isChecked: boolean) => {
    const key = getEnumKeyByValue(enumTypes, select);
    let updatedList;

    if (isChecked) {
      updatedList = [...checkedValue, key];
    } else {
      updatedList = checkedValue.filter((el: string) => el !== key);
    }

    checkFields.onChange(updatedList);
  };

  const onSelectBusinessType = (select: string, isChecked: boolean) => {
    //기업 구분 ETC 선택값
    const ETC_VALUES = ['ETC', 'STARTUP', 'SMALL'];
    const key = getEnumKeyByValue(enumTypes, select);

    let updatedList;

    if (isChecked) {
      if (key === 'ETC') {
        updatedList = [...checkedValue, ...ETC_VALUES];
      } else {
        updatedList = [...checkedValue, key];
      }
    } else {
      if (key === 'ETC') {
        updatedList = checkedValue.filter((el: string) => !ETC_VALUES.includes(el));
      } else {
        updatedList = checkedValue.filter((el: string) => el !== key);
      }
    }

    checkFields.onChange(updatedList);
  };

  const onSelectChekBox = (select: string, isChecked: boolean) => {
    if (prefix === 'businessSizeTypes') onSelectBusinessType(select, isChecked);
    else onSelectOtherType(select, isChecked);
  };

  const checkboxListEl = enumValues.map((item, index) => {
    const key = getEnumKeyByValue(enumTypes, item);
    const isChecked = checkedValue.includes(key);

    return (
      <div className={cx('checkboxInner')} key={index}>
        <div className={cx('checkboxWrap')}>
          <Checkbox
            type={'square'}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSelectChekBox(item, e.target.checked)}
            checked={isChecked}
          >
            <span className={cx('labelText')}>{item}</span>
          </Checkbox>
        </div>
      </div>
    );
  });

  return (
    <div className={cx('filterWrap')}>
      <div className={cx('filterTitleArea')}>
        <em className={cx('filterTitle')}>{title}</em>
        <a className={cx('btnFilter')} role="button" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? (
            <Icon name="largeArrowTopLight" width={24} height={24} />
          ) : (
            <Icon name="largeArrowBottomLight" width={24} height={24} />
          )}
        </a>
      </div>

      {isOpen && <div className={cx('checkboxArea')}>{checkboxListEl}</div>}
    </div>
  );
};

export default CheckboxArea;
